import GlossaryTooltip from 'blocks/glossaryTooltip/glossaryTooltip.component';
import classNames from 'classnames';
import { graphql } from 'gatsby';
import React, { useEffect, useState } from 'react';
import './paragraph.scss';

interface Props {
  content: string;
  glossary?: any[];
  index: number;
}

export const query = graphql`
  fragment ParagraphBlock on WpCoreParagraphBlock {
    attributes {
      ... on WpCoreParagraphBlockAttributes {
        content
      }
    }
  }
`;

const Paragraph: React.FC<Props> = (props) => {
  const [content, setContent] = useState<string | null>(null);
  const [toolTips, setToolTips] = useState<any[]>();
  const isItalic = props.content.startsWith('<em>') && props.content.endsWith('</em>');

  useEffect(() => {
    let _content = props.content;

    if (!!props.glossary) {
      const regCode = /<code>(.*?)<\/code>/g;
      const results = [];
      let match = null;
      while ((match = regCode.exec(_content))) {
        results.push(match);
      }

      const _toolTips: any[] = [];
      results.forEach((item, key) => {
        const id = `glossary-tooltip-${props.index}-${key + 1}`;
        //
        if (!!props.glossary) {
          const glossaryItem = props.glossary.find((gItem) => gItem.title === item[1]);
          if (!!glossaryItem) {
            _content = _content.replace(item[0], `<a href="#" id="${id}" className="paragraph-tooltip">${item[1]}</a>`);
            _toolTips.push({
              id,
              content: glossaryItem.content,
            });
          } else {
            _content = _content.replace(item[0], item[1]);
          }
        }
      });
      setToolTips(_toolTips);
    }

    setContent(_content);
  }, [props.content, props.index]);

  if (!content) {
    return <p></p>;
  }

  return (
    <>
      {toolTips?.map((item, key) => (
        <GlossaryTooltip {...item} key={key} />
      ))}
      <p dangerouslySetInnerHTML={{ __html: content }} className={isItalic ? 'is-italic' : undefined} />
    </>
  );
};

export default Paragraph;
